/**
  © BlockyApps. You are permitted to use this content within your store. Redistribution or use in any other application is strictly prohibited. 
  Unauthorized copying, distribution, or reproduction in any form will result in legal action.
**/
if (!customElements.get('blocky-slider-2')) {
  customElements.define('blocky-slider-2',
    class BlockySlider2 extends HTMLElement {
      constructor() {
        super()
        this.track = this.querySelector(".blocky-slider-2-carousel-track");
        this.slides = Array.from(this.track.children);
        this.rightArrow = this.querySelector(".right-arrow")
        this.leftArrow = this.querySelector(".left-arrow")
        this.currentIndex = 0;
        this.isMobile = window.matchMedia("(max-width: 750px)").matches;
        
        // Touch/swipe variables
        this.startX = 0;
        this.currentX = 0;
        this.isDragging = false;
        this.threshold = 50; // Minimum distance to trigger swipe

        // Arrow click events
        if (this.rightArrow) {
          this.rightArrow.addEventListener("click", () => {
            this.nextSlide();
          });
        }
    
        if (this.leftArrow) {
          this.leftArrow.addEventListener("click", () => {
            this.prevSlide();
          });
        }
    
        // Touch events
        this.track.addEventListener("touchstart", this.handleTouchStart.bind(this), { passive: false });
        this.track.addEventListener("touchmove", this.handleTouchMove.bind(this), { passive: false });
        this.track.addEventListener("touchend", this.handleTouchEnd.bind(this), { passive: false });
        
        // Mouse events for desktop drag
        this.track.addEventListener("mousedown", this.handleMouseDown.bind(this));
        this.track.addEventListener("mousemove", this.handleMouseMove.bind(this));
        this.track.addEventListener("mouseup", this.handleMouseUp.bind(this));
        this.track.addEventListener("mouseleave", this.handleMouseUp.bind(this));
        
        // Prevent default drag behavior
        this.track.addEventListener("dragstart", (e) => e.preventDefault());
    
        window.addEventListener("resize", () => {
          this.updateCarousel();
          this.isMobile = window.matchMedia("(max-width: 750px)").matches;
        });
        this.updateArrows()
      }

      updateCarousel() {
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        this.track.style.transform = `translateX(-${this.currentIndex * slideWidth}px)`;
        this.updateArrows()
      }

      updateArrows() {
        if (this.leftArrow) {
          if (this.currentIndex === 0) {
            this.leftArrow.classList.add("disabled")
          } else {
            this.leftArrow.classList.remove("disabled")          
          }
        }
        if (this.rightArrow) {
          let end = this.isMobile ? this.slides.length - 1 : this.slides.length - 3
          if (this.currentIndex >= end) {
            this.rightArrow.classList.add("disabled")
          } else {
            this.rightArrow.classList.remove("disabled")
          }
        }
      }

      // Navigation methods
      nextSlide() {
        let end = this.isMobile ? this.slides.length - 1 : this.slides.length - 3
        if (this.currentIndex < end) {
          this.currentIndex++;
          this.updateCarousel();
        }
      }

      prevSlide() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.updateCarousel();
        }
      }

      // Touch event handlers
      handleTouchStart(e) {
        this.startX = e.touches[0].clientX;
        this.isDragging = true;
        this.track.style.transition = 'none';
      }

      handleTouchMove(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        this.currentX = e.touches[0].clientX;
        const diffX = this.startX - this.currentX;
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        const currentTransform = -this.currentIndex * slideWidth;
        this.track.style.transform = `translateX(${currentTransform - diffX}px)`;
      }

      handleTouchEnd(e) {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.track.style.transition = 'transform 0.5s ease-in-out';
        
        const diffX = this.startX - this.currentX;
        if (Math.abs(diffX) > this.threshold) {
          if (diffX > 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
        } else {
          this.updateCarousel();
        }
      }

      // Mouse event handlers for desktop drag
      handleMouseDown(e) {
        this.startX = e.clientX;
        this.isDragging = true;
        this.track.style.transition = 'none';
        this.track.style.cursor = 'grabbing';
        e.preventDefault();
      }

      handleMouseMove(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        this.currentX = e.clientX;
        const diffX = this.startX - this.currentX;
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        const currentTransform = -this.currentIndex * slideWidth;
        this.track.style.transform = `translateX(${currentTransform - diffX}px)`;
      }

      handleMouseUp(e) {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.track.style.transition = 'transform 0.5s ease-in-out';
        this.track.style.cursor = 'grab';
        
        const diffX = this.startX - this.currentX;
        if (Math.abs(diffX) > this.threshold) {
          if (diffX > 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
        } else {
          this.updateCarousel();
        }
      }

    }
  )
}
